<template>
    <div> 
        <div style="margin-bottom: 10px;margin-top: 25px"> 
            <h1 style="font-size: 24px; color: black;">兑换记录</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="120px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label="商品名称：">
                    <el-input v-model="queryData.name" style="width: 110px" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品类型：">
                    <el-select v-model="queryData.type" >
                        <el-option v-for="item in goodType" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品来源:">
                    <el-select v-model="queryData.origin" clearable>
                        <el-option v-for="item in origins" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" ">
                    <el-button  type="primary" @click="query">查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        </div>

        <div>
            <el-table border :data="exchangeRecords">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="id" width="50" label="id"></el-table-column>
                <el-table-column prop="create_dt" label="创建日期" :formatter="formatDate"></el-table-column>
                <el-table-column prop="update_dt" label="更新日期" :formatter="formatDate"></el-table-column>
                <el-table-column prop="name" label="物品名称"></el-table-column>
                <el-table-column prop="origin"  label="平台来源" width="100px" :formatter="formatOrigin" > </el-table-column>
                <el-table-column prop="goods_type" label="商品类型"  width="100px" :formatter="formatGoodsType" ></el-table-column>
                <el-table-column prop="order_id" label="订单号"></el-table-column>
                <el-table-column prop="number" label="数量"></el-table-column>
                <el-table-column prop="phone" label="手机号"></el-table-column>
                <el-table-column prop="province" label="省份信息"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createDt" label="领取时间" :formatter="formatDate"></el-table-column>
                <el-table-column prop="did" label="用户编号"></el-table-column>
                <el-table-column prop="user_name" label="用户名称"></el-table-column>
                <el-table-column prop="dt" label="日期"></el-table-column>
                <el-table-column prop="goods_code" label="商品编号"></el-table-column>
                <el-table-column prop="coin_number" label="红包币数量"></el-table-column>
                <el-table-column prop="discount_price" label="折扣价"></el-table-column>
                <el-table-column prop="good_desc" label="商品描述" :width="200"  :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column  label="商品图片" width="150px" align="center">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.img" width="80px" height="80px" />
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="state" label="发货状态" :formatter="formatStateType"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" round
                                   @click="setReceiveType(scope.row,1)">通过</el-button>
                        <el-button type="warning" round
                                   @click="setReceiveType(scope.row,9)">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[20,50,100]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
            </el-pagination>
        </div>

    </div>

</template>

<script>

import {formatDate,searchExchangeRecord,goodsTypes,goodsOriginTypes,updateExchangeRecordState,recordStateTypes} from "@/http/api";
import utils from "@/utils";

export default {
    inject: ['reload'],
    name: "ExchangeRecord",
    data() {
        return {
            queryData: {
                type: null,
                name:'',
                timeDate: ['', ''],
                origin:null
            },
            queryTrueData: {
                type: null,
                startTime: '',
                endTime: '',
                order: null,
                prop: null,
                origin:null
            },
            headers: {},
            page: {
                size: 20,
                page: 0,
                totalElements: null
            }, 
            goodType:[],
            origins:[],
            exchangeRecords:[],
            VUE_APP_BASE_URL:'',
            VUE_APP_CDN_URL:'',
            steteTypes:[]
        }
    },
    methods: {
        formatDate(row, column) {
            return formatDate(row, column);
        },
        formatDateYMD(row, column) {
            return utils.DateUtil.formatDate(row[column.property], "YYYY-MM-DD");
        }, 
        formatGoodsType: function(row,column,cellValue) {
                var temp="其他"
                this.goodType.forEach( item => {
                    if(item.id===cellValue){
                        temp=item.name;
                        } 
                })
                return temp
        },
        formatOrigin: function(row,column,cellValue) {
                var temp="其他"
                this.origins.forEach( item => {
                    if(item.id===cellValue){
                        temp=item.name;
                        } 
                })
                return temp
        },
        formatStateType: function(row,column,cellValue) {
                var temp="其他"
                this.steteTypes.forEach( item => {
                    if(item.id===cellValue){
                        temp=item.name;
                        } 
                })
                return temp
        },        
        query() {
                this.queryTrueData.startTime = this.queryData.timeDate[0];
                this.queryTrueData.endTime = this.queryData.timeDate[1];
                this.queryTrueData.name = this.queryData.name;
                this.queryTrueData.type = this.queryData.type;
                this.queryTrueData.size = this.page.size;
                this.queryTrueData.page = this.page.page;
                this.queryTrueData.origin = this.queryData.origin;
                searchExchangeRecord(this.queryTrueData).then(resp => {
                    this.exchangeRecords = resp.data.info.list;
                    this.$forceUpdate();
                    this.page.totalElements = resp.data.info.totalElements;
                });
        },
        setReceiveType(row, receiveType) {
            updateExchangeRecordState({
                "id": row.id,
                "state": receiveType,
                "did": row.did
            }).then(resp => {
                if (resp.data.status === 0) this.query()
            });
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.query();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.query();
        },
    },
    created() {
        this.headers ={Authorization : this.$store.state.user.token};
        goodsOriginTypes().then( resp => {
            this.origins =  resp.data.info;
        } )
        goodsTypes().then( resp => {
            this.goodType =  resp.data.info;
        } )
        recordStateTypes().then( resp => {
            this.steteTypes =  resp.data.info;
        } )        
        this.query();
    },
        mounted() {
            this.VUE_APP_BASE_URL=process.env.VUE_APP_BASE_URL;
            this.VUE_APP_CDN_URL= process.env.VUE_APP_CDN_URL;
        }
}
</script>

<style lang="less">
.sub {
    position: relative;
    left: 570px
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 60px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 60px;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar1 {
    width: 150px;
    height: 200px;
    display: block;
}

.elalert {
    max-width: 89%;
    left: 11%;
}

.iconSize {
    font-size: 14px;
    font-weight: normal;
}

</style>
